export const SOCIAL_NETWORK_GOOGLE = 'G';
export const SOCIAL_NETWORK_APPLE = 'A';
